// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./bahnschrift.ttf");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./abel.ttf");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, "@font-face { \r\n    font-family: 'bahnschrift';/*自定义字体名称*/\r\n    src: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");/*字体文件路径*/\r\n    font-weight: normal;\r\n    font-style: normal;\n}\n@font-face { \r\n    font-family: 'abel';/*自定义字体名称*/\r\n    src: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");/*字体文件路径*/\r\n    font-weight: normal;\r\n    font-style: normal;\n}", ""]);
// Exports
module.exports = exports;
